import SuperagentApi from '../assets/utils/superagent'

export default class ActivityService {
  static async getPlanList() {
    const plantServerConfig = _.get(
      Wiz,
      'globalSettings.dynamicModules.modules["visualization-cockpit"].config'
    ).plantServerConfig
    const superagentApi = new SuperagentApi({ baseUrl: plantServerConfig.baseUrl })
    const [err, res] = await superagentApi.get('/api/Activity/activity', {
      params: {
        SiteId: plantServerConfig.siteId,
        ActivityTypeStr: '0,1',
        Name: '',
      },
    })
    return [err, res]
  }
  static async getActivityModel(params) {
    const plantServerConfig = _.get(
      Wiz,
      'globalSettings.dynamicModules.modules["visualization-cockpit"].config'
    ).plantServerConfig
    const superagentApi = new SuperagentApi({ baseUrl: plantServerConfig.baseUrl })
    const [
      err,
      res,
    ] = await superagentApi.get(
      `/api/Activity/get_fived_simulation_list/${params.processId}/${params.activityId}/${params.startTime}/${params.finishDate}/${params.actualStartDate}/${params.actualEndDate}`,
      { params: {} }
    )
    return [err, res]
  }
}
